const emitWithSocket = (socket, eventName, payload) =>
  new Promise((resolve) => {
    if (!socket) {
      resolve({
        status: false,
        error: "Socket connection is not available.",
        data: null,
      });
      return;
    }

    socket.emit(eventName, payload, (response) => {
      resolve(response || {});
    });
  });

export const emitAddParticipant = (socket, payload) =>
  emitWithSocket(socket, "add-participant", payload);

export const emitUpdateParticipant = (socket, payload) =>
  emitWithSocket(socket, "update-participant", payload);

export const emitReassignTeamParticipant = (socket, payload) =>
  emitWithSocket(socket, "reassign-team-participant", payload);

export const emitAssignTeamParticipant = (socket, payload) =>
  emitWithSocket(socket, "assign-team-participant", payload);

export const emitUnassignTeamParticipant = (socket, payload) =>
  emitWithSocket(socket, "unassign-team-participant", payload);

export const emitUpdateGameParticipant = (socket, payload) =>
  emitWithSocket(socket, "update-game-participant", payload);

export const emitResetGameLink = (socket, payload) =>
  emitWithSocket(socket, "reset-game-link", payload);

export const emitCancelHelpRequest = (socket, payload) =>
  emitWithSocket(socket, "cancel-help-request", payload);

export const emitUpdateGameLinkStatus = (socket, payload) =>
  emitWithSocket(socket, "update-game-link-status", payload);

export const emitUpdateTeamParticipantTimezone = (socket, payload) =>
  emitWithSocket(socket, "update-team-participant-timezone", payload);

export const emitRandomAssignParticipants = (socket, payload) =>
  emitWithSocket(socket, "random-assign-participants", payload);

export const emitCheckDatabaseStatus = (socket, payload) =>
  emitWithSocket(socket, "check-database-status", payload);
